import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ConnectedFlightsManagerLegDesktop } from '../FlightsManagerLegDesktop';
import { FieldType } from '../../../models';
import { DeleteSegmentDesktop } from './DeleteSegment';
import { DateDesktop } from '../DesktopFields';
import { ConnectedPaxSelectorDesktop } from '../../PaxSelector';

export class SegmentDesktop extends PureComponent {
    onChangeFocus = (field, focus) => {
        const { onChangeFocus, index } = this.props;
        onChangeFocus(index, field, focus);
    };

    render() {
        const { fieldFocused, index } = this.props;

        return (
            <div className="odf-row-fluid odf-row-nogutter odf-row-top odf-space-outer-bottom-s">
                <ConnectedFlightsManagerLegDesktop
                    fieldFocused={fieldFocused}
                    onChangeFocus={this.onChangeFocus}
                />
                <div
                    className="odf-col"
                    data-testid="departure-date-picker"
                >
                    <DateDesktop
                        isDatesRangeShown={false}
                        open={fieldFocused === FieldType.DATE}
                        onChangeFocus={this.onChangeFocus}
                        placeholderKey="calendar.departureDate"
                    />
                </div>
                <div className="odf-col odf-col-sm">
                    <ConnectedPaxSelectorDesktop disabled={!!index} />
                </div>
                <div className="odf-col odf-col-sm">
                    <DeleteSegmentDesktop index={index} />
                </div>
            </div>
        );
    }
}
SegmentDesktop.propTypes = {
    index: PropTypes.number.isRequired,
    onChangeFocus: PropTypes.func.isRequired,
    fieldFocused: PropTypes.string,
};

SegmentDesktop.defaultProps = {
    fieldFocused: null,
};
